<table [dataSource]="items" mat-table matSort class="condensed">
  <ng-container matColumnDef="name">
    <th *matHeaderCellDef mat-header-cell mat-sort-header>Låntagare</th>
    <td *matCellDef="let customer;" mat-cell>
      <a [routerLink]="['/', 'home', 'guide', customer.id, customer.step]">
        @for (name of customer.names; track $index) {
          <div>{{ name }}</div>
        }
      </a>
    </td>
  </ng-container>

  <ng-container matColumnDef="advisor">
    <th *matHeaderCellDef mat-header-cell mat-sort-header>Rådgivare</th>
    <td *matCellDef="let customer;" mat-cell>
      {{ customer.advisor }}
    </td>
  </ng-container>

  <ng-container matColumnDef="office">
    <th *matHeaderCellDef mat-header-cell mat-sort-header>Kontor</th>
    <td *matCellDef="let customer;" mat-cell>
      {{ customer.office }}
    </td>
  </ng-container>

  <ng-container matColumnDef="status">
    <th *matHeaderCellDef mat-header-cell mat-sort-header>Status</th>
    <td *matCellDef="let customer;" mat-cell>
      <spb-approval-status-marker [status]="customer.status || 'created'"/>
    </td>
  </ng-container>

  <ng-container matColumnDef="date">
    <th *matHeaderCellDef mat-header-cell mat-sort-header>Datum</th>
    <td *matCellDef="let customer;" mat-cell>
      {{ customer.date |date: 'yyyy-MM-dd HH:mm' }}
    </td>
  </ng-container>

  <ng-container matColumnDef="delete">
    <th *matHeaderCellDef mat-header-cell mat-sort-header>Radera</th>
    <td *matCellDef="let customer;" mat-cell>
      <button matIconButton (click)="delete(customer.id)">
        <mat-icon class="negative">delete</mat-icon>
      </button>
    </td>
  </ng-container>

  <tr *matHeaderRowDef="columns()" mat-header-row></tr>
  <tr *matRowDef="let row; columns: columns()" mat-row></tr>
</table>
<mat-paginator [pageSizeOptions]="[25, 50, 100, 1000]"
               [pageSize]="25" showFirstLastButtons>
</mat-paginator>
